"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudentHasNoReports = void 0;
const client_library_1 = require("@seneca/client-library");
class StudentHasNoReports extends client_library_1.ExtendableError {
    constructor(studentId) {
        super(`No reports found for student with ID: ${studentId}`);
    }
}
exports.StudentHasNoReports = StudentHasNoReports;
//# sourceMappingURL=StudentHasNoReports.js.map